export const TRANSLATION_INIT = 'TRANSLATION:INIT'
export const TRANSLATION_FETCH = 'TRANSLATION:FETCH'
export const TRANSLATION_FETCH_SUCCESS = 'TRANSLATION:FETCH:SUCCESS'
export const TRANSLATION_FETCH_FAIL = 'TRANSLATION:FETCH:FAIL'
